export default __webpack_public_path__ + "static/media/clean.71a4f4d2.svg";